import { Button, Card, Divider, Flex } from 'antd'
import { useState } from 'react'

import { useIdentityRolesServiceGetRolesListEndpoint } from 'src/api/queries'
import { Permissions } from 'src/api/requests'
import { PageBreadcrumbs, SearchBar, Select } from 'src/components'
import { useUser } from 'src/hooks'
import { useLocales } from 'src/locales'
import { getOrderingDirection, normalizeOrdering } from 'src/utils'

import { RolesFormModal, RolesTable } from '../components'
import { useConfig } from '../hooks'

export const Roles = () => {
  const { t } = useLocales()
  const { orderingOptions } = useConfig()

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [roleId, setRoleId] = useState<string>()

  const [search, setSearch] = useState('')
  const [ordering, setOrdering] = useState('')

  const { userData } = useUser()

  const { hasPermission } = useUser()

  const canViewAll = hasPermission(Permissions.IDENTITY_ROLES_VIEW_ALL)

  const queryParams = {
    ...(!!search && {
      searchTerm: search
    }),
    ...(!!ordering && {
      sortBy: normalizeOrdering(ordering),
      sortDirection: getOrderingDirection(ordering)
    }),
    legalEntityId: canViewAll
      ? undefined
      : String(userData?.currentLegalEntityId)
  }

  const { data, isLoading } = useIdentityRolesServiceGetRolesListEndpoint({
    ...queryParams
  })

  const onToggle = () => setIsOpenModal((prev) => !prev)

  const onCancel = () => {
    onToggle()
    setRoleId(undefined)
  }

  return (
    <PageBreadcrumbs
      title={t('menu.roles')}
      items={[
        {
          title: t('menu.roles')
        }
      ]}
    >
      <Flex gap={16}>
        <SearchBar onSearch={(val) => setSearch(val)} />

        <Select
          options={orderingOptions}
          onSelect={(opt) => setOrdering(opt)}
          placeholder={t('common.sort_by')}
        />

        {canViewAll && (
          <Button type="primary" onClick={onToggle}>
            {t('roles.add_new_role')}
          </Button>
        )}
      </Flex>

      <Divider />
      <Card bordered={false}>
        <RolesTable
          onEdit={(id: string) => {
            setRoleId(id)
            setIsOpenModal(true)
          }}
          loading={isLoading}
          data={data}
          title={t('roles.system_roles')}
        />
      </Card>

      {isOpenModal && <RolesFormModal onCancel={onCancel} roleId={roleId} />}
    </PageBreadcrumbs>
  )
}
